import React, { Component } from "react"
import {
	Button,
	Nav,
	NavItem,
	Grid,
	Row,
	Col,
	Jumbotron,
	Image,
	Panel,
} from "react-bootstrap"
import "./FrontPage.css"
import { LinkContainer } from "react-router-bootstrap"

const featureImagePaths = [
	"/features/portfolio.png",
	"/features/accounts.png",
	"/features/transactions.png",
	"/features/conversion.png",
]

export default class FrontPage extends Component {
	constructor(props) {
		super(props)
		this.state = {
			selectedFeatureIndex: 0,
		}
	}

	render() {
		return (
			<Grid className="front-grid">
				<Row>
					<Jumbotron>
						<h1 className="front-heading">
							The Automatic Cryptocurrency Tracker
						</h1>
						<p className="front-subheading">
							See how hundreds of traders are using Crypto Portfolio Tracker to
							track their digital assets.
						</p>
						{this.startTrialButton(
							"front-trial-button",
							"Start 10-day free trial »"
						)}
					</Jumbotron>
				</Row>
				<Row>
					<h2 className="front-heading2">Automatic Tracking</h2>
					<p className="front-subheading2">
						Your portfolio market value, profit and loss, and asset allocation
						are calculated without having to do manual trade entry.
					</p>
				</Row>
				<Row>
					<Col md={4}>
						<Nav
							className="front-feature-nav"
							bsStyle="pills"
							stacked
							activeKey={this.state.selectedFeatureIndex}
						>
							<NavItem eventKey={0} onSelect={this.featureSelectHandler(0)}>
								<p className="front-feature-heading">
									Automatic gains calculation
								</p>
								<p>
									Know how much you paid for an asset and the immediate gain if
									you were to sell.
								</p>
							</NavItem>
							<NavItem eventKey={1} onSelect={this.featureSelectHandler(1)}>
								<p className="front-feature-heading">API-based sync</p>
								<p>
									Automatically fetch your balance and trade history from
									multiple exchanges.
								</p>
							</NavItem>
							<NavItem eventKey={2} onSelect={this.featureSelectHandler(2)}>
								<p className="front-feature-heading">Transaction history</p>
								<p>See realized profit and details for past trades.</p>
							</NavItem>
							<NavItem eventKey={3} onSelect={this.featureSelectHandler(3)}>
								<p className="front-feature-heading">Price conversion</p>
								<p>Click on any price to see it in multiple currencies.</p>
							</NavItem>
						</Nav>
					</Col>
					<Col md={8}>
						<Image
							className="front-feature-image"
							src={featureImagePaths[this.state.selectedFeatureIndex]}
							responsive
							rounded
						/>
					</Col>
				</Row>
				<Row />
				<Row>
					<h2 className="front-heading3">Supported Exchanges</h2>
				</Row>
				<Row>
					{LogoImageCol("/logos/bitfinex.png")}
					{LogoImageCol("/logos/binance.svg")}
					{LogoImageCol("/logos/bittrex.png")}
					{LogoImageCol("/logos/gdax.png")}
					{LogoImageCol("/logos/kraken.png")}
					{LogoImageCol("/logos/poloniex.png")}
				</Row>
				<Row>
					<h2>Plans & Pricing</h2>
					<p className="front-subheading2">
						Free 10 day trial. No credit card required!
					</p>
				</Row>
				<Row className="front-price-row">
					<Col md={2} />
					<Col className="front-price-col" md={4}>
						<Panel>
							<div className="front-plan">
								<p className="plans-title">Standard</p>
								<p className="plans-price">$29.95</p>
								<p className="plans-price-detail">1 year</p>
								<p>For crypto traders and holders</p>
								<p>
									Track <b>unlimited transactions</b> on up to{" "}
									<b>4 exchanges</b>
								</p>
								{this.startTrialButton("front-buy-button")}
							</div>
						</Panel>
					</Col>
					<Col className="front-price-col" md={4}>
						<Panel>
							<div className="front-plan">
								<p className="plans-title">Pro</p>
								<p className="plans-price">$39.95</p>
								<p className="plans-price-detail">1 year</p>
								<p>For advanced traders</p>
								<p>
									Track <b>unlimited transactions</b> on up to{" "}
									<b>6 exchanges</b>
								</p>
								{this.startTrialButton("front-buy-button")}
							</div>
						</Panel>
					</Col>
					<Col md={2} />
				</Row>
			</Grid>
		)
	}

	featureSelectHandler(index) {
		return () => {
			this.setState({
				selectedFeatureIndex: index,
			})
		}
	}

	startTrialButton(className, text = "Start Trial »") {
		return (
			<LinkContainer to="/sign-in">
				<Button className={className} bsStyle="primary" bsSize="large">
					{text}
				</Button>
			</LinkContainer>
		)
	}
}

function LogoImageCol(path) {
	return (
		<Col className="front-logo-col" md={2} xs={2}>
			<Image className="front-logo-image" src={path} responsive />
		</Col>
	)
}



// WEBPACK FOOTER //
// ./src/FrontPage.js